<section>
    <dl class="my-6" [class.mb-6]="isLast()">
        <dt>
            <button
                type="button"
                class="text-neutral-20 flex w-full cursor-pointer items-center justify-between text-left"
                (click)="toggleAccordion()"
            >
                <span class="text-title-medium">{{
                    accordionBlock().translations_refs | getTranslation: "title"
                }}</span>
                <svg-icon
                    [class.rotate-180]="isExpanded()"
                    class="text-primary"
                    [svgStyle]="{ width: '24px', height: '24px' }"
                    src="assets/icons/Arrow-Down-1.svg"
                />
            </button>
        </dt>
        <dd class="mt-2 pr-12" [class.hidden]="!isExpanded()">
            <packbo-dynamic-page [blocks]="nestedBlocks()" />
        </dd>
        @if (!isLast()) {
            <div class="border-neutral-variant-40/20 border-b pb-6"></div>
        }
    </dl>
</section>
